import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestComponent } from './request.component';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule,
      DragDropModule,
      SharedModule],
    declarations: [RequestComponent],
    exports: [RequestComponent,
      //DndModule
      ],
})

export class RequestModule { }
